import { Footer, Tabs } from 'components';

import { PersonalInfo } from './PersonalInfo';
import { BillingMethod } from './BillingMethod';
import { Preferences } from './Preferences';
import { Container } from '@chakra-ui/react';

const tabList = [{
    id: 1,
    title: 'Personal Info',
    content:<PersonalInfo />
  },
  {
    id: 2,
    title: 'Billing Method',
    content: <BillingMethod />
  },
  {
    id: 3,
    title: 'Preferences',
    content: <Preferences  />
  }];

const Profile = () => {

  return (
    <Container maxWidth='70%'>
     <Tabs width="200px" tabList={tabList}  orientation="vertical" />
     <Footer />
    </Container>
  );
};

export { Profile };
